angular.module('app.controllers').controller 'SpeakersCtrl', [
  '$scope', '$rootScope', 'Table', 'UI', 'APIRead', 'APIReadTable', '$interval', 'APIChats'
].append (self, root, Table, UI, APIRead, APIReadTable, $interval, APIChats) ->

  tableName   = 's.experts.' + (root.user?.shortcode || 'test')
  cookiesName = 't.' + tableName

  self.experts = Table
    name: tableName
    type: "partial"
    resource: APIReadTable
    params:
      limit: 24
      entry_type: 'experts,speakers'
      lang: root.lang
  
  self.$watch 'experts.params', (newObj, oldObj) ->
    self.page = 1
  , true

  self.$watch 'experts.data.display', (newObj, oldObj) ->
    getChatRooms()
  , true

  self.page = 1
  self.loadMore = () ->
    return if self.page >= self.experts.data.pages
    
    self.page++ 
    
    params = angular.copy(self.experts.params)
    params.page = self.page

    self.moreLoad = true
    APIRead.query params, (data) ->
      self.more = data
      self.experts.data.display = self.experts.data.display.concat(self.more)
      self.moreLoad = false



  self.openSpeakerModal = (data = null, id = null) ->
    root.$broadcast 'onSpeakerModalOpen', data, id

  #self.contactModalEl = document.getElementById('contactModal')
  #self.contactModal = bootstrap.Modal.getOrCreateInstance(self.contactModalEl) if self.contactModalEl
  
  getChatRooms = () ->

    accounts = self.experts.data.display?.map((expert) -> return expert.chataccount).filter((expert) -> return expert)
    return unless accounts.length

    APIChats.query {_entry: 'meetings', accounts: accounts.join(","), include_offline: true}, (data) ->
      data.forEach (item) ->
        self.experts.data.display.find((expert) -> expert.chataccount == item.account.id)?.room = item

      
  roomsInterval = $interval getChatRooms, 30000

angular.module('app.controllers').controller 'SpeakersModalCtrl', [
  '$scope', '$rootScope', 'APISpeakers', 'UI'
].append (self, root, APISpeakers, UI) ->

  self.id = null
  self.data = null

  self.speakerModalEl = document.getElementById('speakerModal')

  getSpeaker = () ->
    APISpeakers.get {id: self.id}, (data) ->
      self.data = data      
    , (response) ->
      UI.notify false, response.data.error

  if self.speakerModalEl
    self.speakerModal = bootstrap.Modal.getOrCreateInstance(self.speakerModalEl)
  
    self.speakerModalEl.addEventListener('hidden.bs.modal', (event) ->
      self.id = null
      self.data = null
      self.$applyAsync()
    )

    self.speakerModalEl.addEventListener('show.bs.modal', (event) ->
      getSpeaker() unless self.data
      self.$applyAsync()
    )

  self.$on 'onSpeakerModalOpen', (event, data = null, id = null, modal = true) ->
    self.id = id
    self.data = data
    if modal
      self.speakerModal.show() 
    else
      getSpeaker()
